/**
 * UserCreateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserCreateReq
 */
export interface UserCreateReq {
  /** 访客用户ID（为空则创建新用户） */
  guest_id?: any
  /** 用户名 */
  username: string
  /** 昵称 */
  nickname: string
  /** 密码 */
  password: any
  /** 性别 */
  gender?: string
  /** 生日 */
  birthday?: any
  /** 个人简介 */
  bio?: any
  /** 国家/地区代码 */
  region?: string
  /** 界面语言区域 */
  locale?: string
  /** 用户类型 */
  type: string
  /** 头像文件ID */
  avatar_id?: any
  /** 背景图文件ID */
  background_id?: any
  /** 如果用户已存在且未删除则跳过 */
  skip_if_exists?: boolean
  /** 如果用户已软删除则恢复 */
  restore_if_deleted?: boolean
}

/**
 * UserCreateReq Schema
 */
export const UserCreateReqSchema: SchemaDefinition = {
  properties: {
    guest_id: {
      description: '访客用户ID（为空则创建新用户）',
      format: 'string',
      type: 'user',
      label: '访客用户ID',
    },
    username: {
      description: '用户名',
      format: 'string',
      maxLength: 30,
      minLength: 3,
      type: 'string',
      label: '用户名',
    },
    nickname: {
      description: '昵称',
      format: 'string',
      maxLength: 30,
      minLength: 1,
      type: 'string',
      label: '昵称',
    },
    password: {
      description: '密码',
      format: 'string',
      maxLength: 32,
      minLength: 6,
      type: 'password',
      label: '密码',
    },
    gender: {
      description: '性别',
      format: 'cons.UserGender',
      type: 'string',
      label: '性别',
    },
    birthday: {
      description: '生日',
      format: '*time.Time',
      type: 'date',
      label: '生日',
    },
    bio: {
      description: '个人简介',
      format: 'string',
      maxLength: 500,
      type: 'text',
      label: '个人简介',
    },
    region: {
      description: '国家/地区代码',
      format: 'cons.Region',
      type: 'string',
      label: '国家/地区代码',
    },
    locale: {
      description: '界面语言区域',
      format: 'cons.Locale',
      type: 'string',
      label: '界面语言区域',
    },
    type: {
      description: '用户类型',
      format: 'cons.UserType',
      type: 'string',
      label: '用户类型',
    },
    avatar_id: {
      description: '头像文件ID',
      format: 'string',
      type: 'image',
      label: '头像文件ID',
    },
    background_id: {
      description: '背景图文件ID',
      format: 'string',
      type: 'image',
      label: '背景图文件ID',
    },
    skip_if_exists: {
      description: '如果用户已存在且未删除则跳过',
      format: 'bool',
      type: 'boolean',
      label: '如果用户已存在且未删除则跳过',
    },
    restore_if_deleted: {
      description: '如果用户已软删除则恢复',
      format: 'bool',
      type: 'boolean',
      label: '如果用户已软删除则恢复',
    },
  },
  required: ['username', 'nickname', 'password', 'type'],
  type: 'object',
}
